import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';

const c = initContract();

export const roleTypesContract = c.router(
  {
    list: {
      method: 'GET',
      path: '/',
      responses: {
        200: z.array(DB_SCHEMAS.selectRoleType)
      },
      summary: 'List role types'
    }
  },
  {
    pathPrefix: '/role-types'
  }
);
